import * as React from "react";
import EdButton from "../../generic/edButton";
import LoginFormBtmTxt from "../generic/loginFormBtmTxt";
import RadioButton from "../../generic/radioButton";
import InputField from "../../generic/inputField";
import LoginSecureImg from "../generic/loginSecureImg";
import LoginErrMsg from "../generic/loginErrMsg";
import "../../../assets/scss/Login/login/forms/passwordForm.scss";
import "../../../assets/scss/Login/login/generic/loginInput.scss";

export interface IPasswordFormProps {
  loginId: string; // login id that was entered by the user in loginIdForm
  accTypesObject?: Array<any>; // security image object that comes from api
  disableForm: boolean; // used to disable/enable form from parent
  errorMsg?: string; // error message that came from api
  onEditLoginId: () => void; // when user clicks on edit icon
  onSubmit: (pwd: string, accTyp: string) => void; // function to be called on submit
  onRemoveError: () => void; // removes the errorMsg
  autoFocus?: boolean;
}

// Form fields
export interface IPasswordFormState {
  selectedAcc?: "EQ" | "CO";
  showPassword: boolean;
  secureImgChecked: boolean;
}

const PasswordForm: React.FC<IPasswordFormProps> = (props) => {
  const [selectedAcc, setSelectedAcc] = React.useState<"EQ" | "CO" | undefined>(
    props.accTypesObject ? props.accTypesObject[0] : "EQ"
  );
  const [showPassword, setShowPassword] = React.useState(false);
  const [password, setPassword] = React.useState("");
  
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    props.onSubmit(password, selectedAcc as string);
  }

  function onSelectAcc(accType: "EQ" | "CO" | undefined) {
    setSelectedAcc(accType);
    setShowPassword(false);
    setPassword("");
  }

  // if any field in the below mentioned array is edited && if errorMsg exists, then remove the errorMsg
  React.useEffect(
    (...a) => {
      if (props.errorMsg) {
        props.onRemoveError();
      }
    },
    [password, selectedAcc]
  );

  React.useEffect(() => {
    if (props.accTypesObject && props.accTypesObject.length === 1) {
      setSelectedAcc(props.accTypesObject[0]);
    }
    console.log("props.accTypesObject", props.accTypesObject);
  }, [props.accTypesObject]);

  return (
    <div className="login_form pw_form">
      <form onSubmit={handleSubmit} className="mg-b60">
        <label className="inp_lbl mg-b5 ib">Login ID</label>
        <p className="login_id mg-b40">
          {props.loginId}{" "}
          <i
            className="edel-icon-edit icon mg-l5"
            onClick={props.onEditLoginId}
          />
        </p>

        {/* If there are two security images then the same account name is in both type of accounts */}
        {/* {props.accTypesObject && props.accTypesObject.length > 1 && (
          <div className="same_acc">
            <p className="inp_lbl mg-b5">
              Your current login ID is same in equity & commodity
            </p>
            <p className="inp_lbl mg-b20">Select the account to login</p>
            <ul className="same_acc_radio mg-b40">
              <li className="list_Item">
                <RadioButton
                  list={{
                    value: "EQ",
                    display: "Equity",
                  }}
                  name={"sameAcc"}
                  selected={selectedAcc}
                  onChange={() => onSelectAcc("EQ")}
                />
                <RadioButton
                  list={{
                    value: "CO",
                    display: "Commodity",
                  }}
                  name={"sameAcc"}
                  selected={selectedAcc}
                  onChange={() => onSelectAcc("CO")}
                />
              </li>
            </ul>
          </div>
        )} */}

        <label className="inp_lbl mg-b5 ib">Password</label>
        <InputField
          defaultValue={password}
          id="password"
          type={showPassword ? "text" : "password"}
          onChange={setPassword}
          onBlur={() => {}}
          className="login_inp mg-b40 focus"
          placeholder="Eg:5678987"
          autoFocus={props.autoFocus}
          suffix={
            <i
              className={`edel-icon-eye${showPassword ? "-cross" : ""} icon`}
              onClick={() => setShowPassword(!showPassword)}
            />
          }
        />

        {/* Show error if any */}
        {props.errorMsg && (
          <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
        )}

        <EdButton
          value="Proceed"
          btnTyp="primary"
          className="submit_btn"
          disabled={
            props.disableForm || password.length < 3 
          }
        />
      </form>

      <LoginFormBtmTxt />
    </div>
  );
};

export default PasswordForm;